export const BOARD_GAME_V2_CLIENT_PREFIX = "/v2";
export const BOARD_GAME_V2_GAME_PREFIX = "/v2/games";
export const GAME_PLATFORM_API_PREFIX = "/api/v2/game-platform";
export const GAME_PLATFORM_WS_PATH = "/api/v2/game-platform/ws";

function trimSlashes(value: string): string {
  return value.replace(/^\/+|\/+$/g, "");
}

function encodeSegment(value: string): string {
  return encodeURIComponent(trimSlashes(value));
}

export function buildV2ShellPath(path = ""): string {
  const suffix = trimSlashes(path);
  return suffix.length === 0
    ? BOARD_GAME_V2_CLIENT_PREFIX
    : `${BOARD_GAME_V2_CLIENT_PREFIX}/${suffix}`;
}

export function buildV2GameBasePath(gameType: string): string {
  return `${BOARD_GAME_V2_GAME_PREFIX}/${encodeSegment(gameType)}`;
}

export function buildV2GameRoomPath(gameType: string, roomId: string): string {
  return `${buildV2GameBasePath(gameType)}/rooms/${encodeSegment(roomId)}`;
}

export function buildV2GameReplayPath(
  gameType: string,
  scenario: string,
): string {
  return `${buildV2GameBasePath(gameType)}/replay/${encodeSegment(scenario)}`;
}

export function buildGamePlatformApiPath(path = ""): string {
  const suffix = trimSlashes(path);
  return suffix.length === 0
    ? GAME_PLATFORM_API_PREFIX
    : `${GAME_PLATFORM_API_PREFIX}/${suffix}`;
}

export function buildGamePlatformRoomApiPath(
  roomId: string,
  path = "",
): string {
  const suffix = trimSlashes(path);
  const base = buildGamePlatformApiPath(`rooms/${encodeSegment(roomId)}`);
  return suffix.length === 0 ? base : `${base}/${suffix}`;
}
